import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1E3A5F] text-[#DADCD6]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 py-14 grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif text-3xl text-white" dangerouslySetInnerHTML={{ __html: META.brand }} />
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mt-2">/ {META.tagline}</p>
          <p className="text-sm text-white/60 mt-5 leading-[1.7] max-w-md">An architecture and interiors practice held in partnership. Twenty-six staff, four typologies, two studios. The number of projects in any year does not exceed eight.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mb-3">Studio · London</p>
          <p className="text-sm text-white/85 leading-relaxed">14 Charlotte Road<br />Shoreditch EC2A 3RH</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mb-3">Studio · Lugano</p>
          <p className="text-sm text-white/85 leading-relaxed">Via Vela 6<br />6900 Lugano</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mb-3">Bureau</p>
          <p className="text-sm text-white/85 leading-relaxed">+44 20 7993 0900<br /><span className="text-[#E5C61F]">studio@hadid-vance.com</span></p>
        </div>
      </div>
      <div className="border-t border-white/15 px-6 lg:px-12 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
        <span>© 2026 Hadid & Vance Limited · ARB Reg. 2003-1144 · An architecture partnership</span>
        <div className="flex gap-6">
          <button onClick={() => setPage('projects')} className="hover:text-[#E5C61F]">Projects</button>
          <a href="#" className="hover:text-[#E5C61F]">Press</a>
          <a href="#" className="hover:text-[#E5C61F]">Privacy</a>
        </div>
      </div>
    </footer>
  );
}
